import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import getHashFromUrlLocationUtil from 'utils/location/get-hash-value-from-url'
import { GIFT_SECTION_DOM_ID } from 'modules/gift/constants'

export default function isSelectSampleSelfGiftingUrlLocationUtil () {
  return (
    isSelfGiftingUrlLocationUtil() &&
    getHashFromUrlLocationUtil().includes(GIFT_SECTION_DOM_ID.SELECT_SAMPLES)
  )
}
